import React from "react";
import { Box, Typography } from "@mui/material";
import { ActionModal, NoticeboardButton } from "../shared";

interface PublishScheduledNoticeModalProps {
  open: boolean;
  onClose: () => void;
  noticeTitle: string;
  onConfirm: () => void;
  loading?: boolean;
}

const PublishScheduledNoticeModal: React.FC<PublishScheduledNoticeModalProps> = ({
  open,
  onClose,
  noticeTitle,
  onConfirm,
  loading = false,
}) => {
  return (
    <ActionModal
      open={open}
      onClose={onClose}
      title="Publish now"
      subtitle="Send this notice immediately"
      maxWidth="sm"
      disableBackdropClick={loading}
      footer={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <NoticeboardButton variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </NoticeboardButton>
          <NoticeboardButton
            variant="primary"
            onClick={onConfirm}
            loading={loading}
          >
            Publish now
          </NoticeboardButton>
        </Box>
      }
    >
      <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
        Publish{" "}
        <Typography component="span" fontWeight={600}>
          &ldquo;{noticeTitle}&rdquo;
        </Typography>{" "}
        now? Members will be notified immediately instead of waiting for the
        scheduled time.
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        This notice will move to your sent list and go live right away.
      </Typography>
    </ActionModal>
  );
};

export default PublishScheduledNoticeModal;
